<template>
  <div>
    <v-container style="padding: 0">
      <v-card>
        <v-app-bar
          color="lime accent-3"
          dark
          prominent
          src="https://images.unsplash.com/photo-1596892432589-8e24739cf4bf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80"
          fade-img-on-scroll
          scroll-target="#scrolling-techniques-3"
        >
          <template v-slot:img="{ props }">
            <v-img
              v-bind="props"
              gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)"
            ></v-img>
          </template>

          <v-card-title class="text-center justify-center py-6">
            <h1 class="display-3 white--text font-weight-light">
              Tour Destinations
            </h1>
          </v-card-title>

          <v-spacer></v-spacer>

          <template v-slot:extension>
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="white"
              grow
            >
              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
          </template>
        </v-app-bar>

        <!--     <v-img
      class="white--text align-end"
      height="200px"
      src="https://images.unsplash.com/photo-1596892432589-8e24739cf4bf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80"
    >


        <v-card-title class="text-center justify-center py-6">
          <h1 class="font-weight-bold display-3 white--text">Tour Destinations</h1>
        </v-card-title>

    </v-img> -->

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in items" :key="item">
            <v-card color="basil" flat>
              <v-card-text>
                <v-data-iterator
                  :items="cards"
                  item-key="name"
                  :items-per-page="6"
                  
                  hide-default-footer
                >
                  <template v-slot:default="props">
                    <v-row>
                      <v-col v-for="i in props.items" :key="i">
                        <tour-item></tour-item>
                      </v-col>
                    </v-row>
                  </template>
                </v-data-iterator>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import TourItem from "./../components/TourItem";
export default {
  data() {
    return {
      cards: [1, 2, 3, 4],
      tab: null,
      items: ["Tours", "Packages", "Domestics", "Cruise"],
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  },
  components: {
    TourItem
  }
};
</script>

<style></style>
